import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

import Buttons from "./components/Buttons";
import FooterBackground from "./components/FooterBackground";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";
import Header from "./components/Header";
import HeaderNavs from "./components/HeaderNavs";
import Share from "./components/Share";
import SolutionDisasters from "./components/SolutionDisasters";
import SolutionCardsBadge from "./components/SolutionCardsBadge";
import SolutionNav from "./components/SolutionNav";
import SolutionsFilter from "./components/SolutionsFilter";
import VideoPlayer from "./components/VideoPlayer";

import DataAnim from "./data-attributes/DataAnim";
import DataLink from "./data-attributes/DataLink";
import DataMatchHeight from "./data-attributes/DataMatchHeight";
import DataTextAppear from "./data-attributes/DataTextAppear";
import TitleReveal from "./animations/TitleReveal";
import EscapeEventListener from "./events/EscapeEventListener";
import AsideForm from "./components/AsideForm";
import {GlobalVariables} from "./GlobalVariables";


export default class StarterKit {
	constructor() {
		console.log("%cFabriqué à Lyon par Digital Cover", "background-color:#211450; color:#FF407D;padding:3px 5px;font-family:monospace;", "https://digital-cover.fr");

		// First
		new SmoothScroll();
		new ResizeEvents();
		new EscapeEventListener();
		new EventListeners();
		new MobileCheck();
		new DevHelpers();

		// Data utils
		new DataAnim();
		new DataLink();
		new DataMatchHeight();
		new DataTextAppear();
		new TitleReveal();

		// Components
		new AsideForm();
		new Buttons();
		new FooterBackground();
		new Gallery();
		GlobalVariables.header = new Header();
		new HeaderNavs();
		new RichText();
		new Share();
		new SolutionDisasters();
		new SolutionCardsBadge();
		new SolutionNav();
		new SolutionsFilter();
		new VideoPlayer();
	}
}
